export default {
  methods: {
    isRiskStatus (row) {
      return Number(row.risk_status) === 1
    },
    isHighInvalidPercent (row) {
      return row.total_invalid_percent >= 70
    },
    isCustomerRisk (row) {
      return row && row.order_percent >= 80
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/users/user-risk.mixins.js